module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"boards":"Boards","starred_board":"Starred Boards","recently_board":"Recently Boards","overview":"Overview"},"th":{"boards":"บอร์ด","starred_board":"บอร์ด ที่ติดดาว","recently_board":"บอร์ด ที่เพิ่งเปิดดู","overview":"ภาพรวม"}}')
  delete Component.options._Ctor
}
